import React from "react";
import { Box, Typography, Button } from "@mui/material";
import notFound from "../assets/images/not-found/not-found.png";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  const styles = {
    container: {
      backgroundColor: "#000",
      color: "#fff",
      padding: "12%",
      textAlign: "center",
      flexDirection: "column",
      height: "100vh",
      fontFamily: "Tajawal-Regular",
    },
    heading: {
      fontSize: "4rem",
      fontWeight: "bold",
    },
    subheading: {
      fontSize: "1.5rem",
      margin: "10px 0",
    },
    text: {
      fontSize: "1rem",
      color: "#aaa",
      marginBottom: "20px",
    },
    astronaut: {
      width: "200px",
      height: "200px",
      marginTop: "20px",
    },
    button: {
      padding: "10px 20px",
      borderRadius: "20px",
      background: "linear-gradient(90deg, #00d2ff, #3a7bd5)",
      border: "none",
      color: "#fff",
      cursor: "pointer",
      fontSize: "1rem",
      fontWeight: "bold",
      textDecoration: "none",
    },
  };

  return (
    <Box sx={styles.container}>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        {/* Text Section - 6 Columns */}
        <Grid item size={{ xl: 6, sm: 6, xs: 12 }}>
          <Typography variant="h1" sx={styles.heading}>
            404-error
          </Typography>
          <Typography variant="h2" sx={styles.subheading}>
            PAGE NOT FOUND
          </Typography>
          <Typography sx={styles.text}>
            Your search has ventured beyond the known universe.
          </Typography>
          <Link to="/">
            <Button href="/" sx={styles.button}>
              Back To Home
            </Button>
          </Link>
        </Grid>

        {/* Image Section - 6 Columns */}
        <Grid item size={{ xl: 6, sm: 6, xs: 12 }}>
          <img
            style={styles.astronaut}
            src={notFound}
            alt="Astronaut floating in space"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default NotFoundPage;
